
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.992 14.07c.57 0 1.04-.484 1.04-1.015V8.406h4.554c.547 0 1.023-.469 1.023-1.039 0-.562-.476-1.039-1.023-1.039H8.03V1.68c0-.547-.469-1.016-1.039-1.016-.562 0-1.031.469-1.031 1.016v4.648H1.406c-.531 0-1.023.477-1.023 1.04 0 .57.492 1.038 1.023 1.038h4.555v4.649c0 .53.469 1.015 1.031 1.015z"}})])
          )
        }
      }
    